import React, { useEffect, useState } from 'react';
import {
  AlertBanner,
  Icon,
  TabContent,
  TabGroup,
  TabItem,
} from '@saviynt/design-system';

import { useExtContext } from '../../context';
import { useInvertedLocalize } from '../../utils';

import AllUsersList from './All/UsersList/AllUsersList';
import External from './External/ExternalIdentities/ExternalIdentities';
import Header from './Header/Header';
import { TAB_VALUES } from './constants';
import invertedMessages from './messages';

import './Identities.css';

const DELAY_ALERT_BANNER = 5000 as const;

type TabValue = (typeof TAB_VALUES)[keyof typeof TAB_VALUES];

export default function Identities() {
  const l = useInvertedLocalize(invertedMessages);
  const [activeTab, setActiveTab] = useState<TabValue>(TAB_VALUES.EXTERNAL);
  const [showJobTriggerSuccessBanner, setShowJobTriggerSuccessBanner] =
    useState(false);

  const { extState, updateExtState } = useExtContext();
  const { isJobTriggerSuccess } = extState;

  useEffect(() => {
    if (isJobTriggerSuccess) {
      setShowJobTriggerSuccessBanner(true);
      setTimeout(() => {
        updateExtState('isJobTriggerSuccess', false);
      }, DELAY_ALERT_BANNER);
    }
  }, [isJobTriggerSuccess, updateExtState]);

  const handleChange = (value: TabValue) => setActiveTab(value);

  return (
    <div className='Ext-Identities'>
      <div className='Ext-Identities-content'>
        <Header activeTab={activeTab} />
        <AlertBanner
          colorTheme='Success'
          title={l('External user classification started succesfully.')}
          description=''
          isVisible={showJobTriggerSuccessBanner}
          onCancel={() => setShowJobTriggerSuccessBanner(false)}
          isColonVisible={false}
          autoDismissDelay={DELAY_ALERT_BANNER}
          shouldAutoDismiss
        />
        <div className='Ext-Identities-header-tabGroup'>
          <TabGroup value={activeTab} onChange={handleChange}>
            <TabItem
              label={l('All')}
              value={TAB_VALUES.ALL}
              icon={
                <Icon kind='UserManagement' size='medium' color='neutral-600' />
              }
            />
            <TabItem
              label={l('External')}
              value={TAB_VALUES.EXTERNAL}
              icon={<Icon kind='Workbench' size='medium' color='neutral-600' />}
            />
          </TabGroup>
        </div>
      </div>
      <TabContent value={activeTab} tabValue={TAB_VALUES.ALL}>
        <AllUsersList />
      </TabContent>
      <TabContent value={activeTab} tabValue={TAB_VALUES.EXTERNAL}>
        {activeTab === TAB_VALUES.EXTERNAL && (
          <External isJobTriggerSuccess={isJobTriggerSuccess} />
        )}
      </TabContent>
    </div>
  );
}
